import React from 'react';
import { connect } from 'react-redux';

class InputBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			flag: true
		};
	}

	componentDidMount() {
		if(this.props.notMandatory && this.props.validateFields){
			this.props.validateFields.push({ key: this.props.id, isValid: true, message: true, notMandatory: true })
			this.props.errorFn(this.props.validateFields)
		}else if (this.props.validateFields) {
			this.props.validateFields.push({ key: this.props.id, isValid: false, message: false })
			this.props.errorFn(this.props.validateFields)
		}
		 if(this.props.value && this.props.value !== ''){
            this.props.errorFn && this.props.errorFn(this.getValidateFileds(this.props.id, false, false, true));
        }
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value  && nextProps.value !== '' && this.props.validateFields && this.state.flag) {
			this.props.errorFn(this.getValidateFileds(this.props.id, false, false, true));
			this.setState({ flag: false });
		}
	}

	loadTranslations = (value, currentLanguage) => {
		const currentLang = currentLanguage ? currentLanguage : 'en';
		return this.props.translations ? this.props.translations[value] ? this.props.translations[value][currentLang] ? this.props.translations[value][currentLang] : value : value : value;
	}

	checkDuplicateEmail = (data, column) => {
		if (data.message === 'success') {
			this.props.errorFn(this.getValidateFileds(column, 'This email is already registered with us', false, false))
		} else {
			this.props.errorFn(this.getValidateFileds(column, false, false, true))
		}
	}

	checkDuplicateBusiness = (data, column) => {
		if (data.message === 'success') {
			this.props.errorFn(this.getValidateFileds(column, 'This business is already registered with us', false, false))
		} else {
			this.props.errorFn(this.getValidateFileds(column, false, false, true))
		}
	}

	checkSeries = (data, column) => {
		if (data.message === 'success') {
			this.props.errorFn(this.getValidateFileds(column, 'This series is already there in vaccination', false, false))
		} else {
			this.props.errorFn(this.getValidateFileds(column, false, false, true))
		}
	}

	emailCheck = (value, column) => {
		var regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const emailCheck = regExp.test(String(value).toLowerCase());
		if (emailCheck) {
			this.props.checkDuplicateEmail && this.props.dispatch(this.props.checkDuplicateEmail(value, this.checkDuplicateEmail, column, this.props.businessId))
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, false, false, true));
		} else {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, 'Invalid Email', false))
		}
		this.props.onChange(value, column);
	}

	passwordCheck = (value, column) => {
		if (value.length <= 5) {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, 'Weak password', false, false))
		} else if (value.length >= 6 && value.length <= 9) {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, 'Medium password', false, false))
		} else {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, false, false, true));
		}
		this.props.onChange(value, column);
	}

	confirmPasswordCheck = (value, column) => {
		if (this.props.newPassword === value) {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, false, false, true));
		} else {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, 'Confirm password not match with password', false, false))
		}
		this.props.onChange(value, column);
	}

	urlCheck = (value, column) => {
		const url = /^((https?|ftp|smtp):\/\/)?(www.)?[a-zA-Z0-9-_]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
		const checkUrl = url.test(value);
		if (checkUrl) {
			this.props.checkDuplicateEmail && this.props.dispatch(this.props.checkDuplicateEmail(value, this.checkDuplicateEmail, column))
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, false, false, true));
		} else {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, 'Invalid url', false,))
		}
		this.props.onChange(value, column);
	}

	businessCheck = (value, column) => {
		this.props.checkDuplicateBusiness && this.props.dispatch(this.props.checkDuplicateBusiness(value, this.checkDuplicateBusiness, column))
		this.props.checkDuplicateEmail && this.props.dispatch(this.props.checkDuplicateEmail(this.props.email, this.checkDuplicateEmail, 'email', value))
		this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, false, false, true));
		this.props.onChange(value, column);
	}

	seriesCheck = (value, column) => {
		this.props.checkDuplicatieSeries && this.props.dispatch(this.props.checkDuplicatieSeries(this.props.businessId, value, column, this.checkSeries));
		this.props.onChange(value, column);
	}

	onChangeText = (value, column) => {
		if(value === '' && this.props.notMandatory){
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, false, false, true));
			this.props.onChange(value, column);
			return true
		}else if(value === '' && !this.props.notMandatory){
			const labelVal = column.charAt(0).toUpperCase() + column.slice(1);
			const lab = labelVal.split(/(?=[A-Z])/).join(" ");
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, lab, 'is required'));
			this.props.onChange(value, column);
			return true
		}
		if (value.length >= this.props.length) {
			this.props.errorFn(this.getValidateFileds(column, `More than ${this.props.length} charcters not allowed`, false, false));
		} else {
			if (this.props.fieldType === 'email') {
				this.emailCheck(value, column);
			} else if (this.props.fieldType === 'password' && !this.props.withoutStrength) {
				this.passwordCheck(value, column);
			} else if (this.props.fieldType === 'confirmPassword') {
				this.confirmPasswordCheck(value, column);
			} else if (this.props.fieldType === 'url') {
				this.urlCheck(value, column);
			} else if (this.props.fieldType === 'businessId') {
				this.businessCheck(value, column);
			} else if (this.props.fieldType === 'series') {
				this.seriesCheck(value, column);
			} else {
				this.props.onChange(value, column);
				this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, false, false, true));
			}

		}
	}

	getValidateFileds =  (column, message, message1, isValid) => {
		if (this.props.validateFields) {
			const fields = this.props.validateFields.map((data) => {
				if (data.key === column) {
					data['message'] = message
					data['message1'] = message1
					data['isValid'] = isValid
					return data
				} else {
					return data
				}
			})
			return fields
		} else {
			return this.props.validateFields
		}
	}

	getMessage = () => {
		let message = false;
		if (this.props.validateFields && this.props.isSubmit) {
			this.props.validateFields.map((data) => {
				if (data.key === this.props.id) {
					message = { message: data.message, message1: data.message1 }
				}
			})
		}
		return message
	}

	render() {
		return (
			<div>
				{this.props.label && <div className="login-input-text">{this.loadTranslations(this.props.label, this.props.currentLanguage)} {this.props.mandatory && '*'}</div>}
				{this.props.label && <div style={{ minHeight: 14 }}><div style={{ color: 'red', float: 'right', fontSize: 12, paddingBottom: 2 }}>{this.getMessage() && <span> <span>{this.loadTranslations(this.getMessage().message, this.props.currentLanguage)}</span> <span>{this.loadTranslations(this.getMessage().message1, this.props.currentLanguage)}</span></span>}</div></div>}
				<input placeholder={this.loadTranslations(this.props.placeholder, this.props.currentLanguage) || ''}
					value={this.props.value}
					autoComplete="off"
					type={this.props.type ? this.props.type : 'text'}
					onChange={(e) => this.onChangeText(e.target.value, this.props.id)}
					id={this.props.id}
					onMouseLeave={() => this.props.onMouseLeave ? this.props.onMouseLeave(this.props.id) : {}}
					onBlur={(e) => this.props.onBlur ? this.props.onBlur(e.target.value) : {}}
					readOnly={this.props.readOnly}
					disabled={this.props.disabled}
				/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentLanguage: state.users.currentLanguage,
		translations: state.users.translations
	};
}

export default connect(mapStateToProps)(InputBox);



// WEBPACK FOOTER //
// ./screens/InputBox/InputBox.js